import { render, staticRenderFns } from "./EditTransportFeeModal.vue?vue&type=template&id=963b3942&scoped=true&"
import script from "./EditTransportFeeModal.vue?vue&type=script&lang=js&"
export * from "./EditTransportFeeModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTransportFeeModal.vue?vue&type=style&index=0&id=963b3942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963b3942",
  null
  
)

component.options.__file = "EditTransportFeeModal.vue"
export default component.exports